var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('GlobalHeader',{ref:"header"}),_c('GlobalSidebar'),_c('router-view',{staticClass:"container"}),_c('GlobalFooter',{ref:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }